import React from 'react';
import './LoginErrorMsg.css';

export default function LoginErrorMsg(props) { 
  return (
    <p className="error-message" role="alert">הטופס לא נשלח בגלל שחלק מהפרטים חסרים: <span className="error-fields">{props.error_message}</span> </p>

  )
}
